import { pushEnrichedEventToDataLayerWithCleanUp } from "seneca-common/features/analytics";
import { withLogAndSwallowError } from "seneca-common/utils/senecaAnalytics";

import {
  NewQuizSessionAnalyticsPayload,
  QuizSessionAnalyticsPayload,
  QuizSessionXpAnalyticsPayload
} from "./types";

export const MAGIC_QUIZ_SESSION_TYPE = "magic-quiz";

export const makeEventName = (event: string) => {
  return `seneca/session/${event}`;
};

export const analyticsLogCompleteQuizSession =
  withLogAndSwallowError(completeQuizSession);

export const analyticsLogStartQuizSession =
  withLogAndSwallowError(startQuizSession);

export const analyticsLogNewQuizSession =
  withLogAndSwallowError(newQuizSession);

export const analyticsLogQuitQuizSession =
  withLogAndSwallowError(quitQuizSession);

export const analyticsUpdateQuizSessionXp =
  withLogAndSwallowError(updateSessionXp);

function completeQuizSession(payload: QuizSessionAnalyticsPayload) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName("completeQuizSession"),
    payload
  });
}

function startQuizSession() {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName("start"),
    payload: {}
  });
}

function newQuizSession(payload: NewQuizSessionAnalyticsPayload) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName("NEW_SESSION"),
    payload: {
      ...payload,
      sessionType: MAGIC_QUIZ_SESSION_TYPE
    }
  });
}

function quitQuizSession() {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName("QUIT_SESSION"),
    payload: {}
  });
}

function updateSessionXp(payload: QuizSessionXpAnalyticsPayload) {
  const { breakdown, ...restPayload } = payload;
  pushEnrichedEventToDataLayerWithCleanUp({
    event: makeEventName("UPDATE_SESSION_XP"),
    payload: {
      ...breakdown,
      ...restPayload
    }
  });
}
